module.exports = __webpack_public_path__ + "static/media/fastag_2.67db329f.svg";